import React from 'react';
import Carousel from 'react-multi-carousel';
import CommonService from '../../../../services/commonService';

const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 4,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

const ThemeFiveSlider = props => {
  const operator = CommonService.getLocal('op');

  const getColor = () => {
    if (
      operator &&
      operator.operator_name === 'trrass' &&
      operator.color_codes &&
      operator.color_codes.tertiary_color
    ) {
      return operator.color_codes.tertiary_color;
    }
    //  else if (
    //   operator &&
    //   operator.operator_name !== 'trrass' &&
    //   operator.color_codes &&
    //   operator.color_codes.primary_color
    // ) {
    //   return operator.color_codes.primary_color;
    // }
    if (
      operator &&
      operator.operator_name === 'centraltour' &&
      operator.color_codes &&
      operator.color_codes.button_color
    ) {
      return operator.color_codes.button_color;
    } else {
      return '#018137';
    }
  };

  return (
    <div className="themes-theme-five-slider  new-container">
      <style>
        .themes-theme-five-slider .react-multi-carousel-dot--active button {'{'}
        background:
        {/* {operator && operator.color_codes && operator.color_codes.primary_color
          ? operator.color_codes.primary_color
          : '#018137'} */}
        {getColor()};{'}'}
      </style>
      <Carousel
        responsive={responsive}
        swipeable={false}
        draggable={false}
        showDots={true}
        infinite={true}
        autoPlay={true}
        autoPlaySpeed={3000}
        customTransition="all .5"
        transitionDuration={3000}
        removeArrowOnDeviceType={['desktop', 'tablet', 'mobile']}
      >
        {props.slides &&
          (props.slides.length || []) > 0 &&
          props.slides.map((slide, index) => {
            return <SlideItem slide={slide} index={index} />;
          })}
      </Carousel>
    </div>
  );
};

const SlideItem = props => {
  return (
    <div className="slide-item" key={props.index}>
      {/* <div className="top-strip-1" style={{ backgroundColor: props.themeColor3 }}></div>
      <div
        className="top-strip-2"
        style={
          props.itemNo % 2 === 0
            ? { backgroundColor: props.themeColor1 }
            : { backgroundColor: props.themeColor2 }
        }
      ></div> */}
      <div className="image-container">
        <img className="image" src={props.slide} alt="slide-item" />
      </div>
    </div>
  );
};

export default ThemeFiveSlider;



// WEBPACK FOOTER //
// ./src/features/themes/theme5/components/ThemeFiveSlider.js